(() => {
    'use strict'
  
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll('#edit_profile_form')
  
    // Loop over them and prevent submission
    Array.from(forms).forEach(form => {
      form.addEventListener('submit', event => {
        if (!form.checkValidity()) {
          event.preventDefault()
          event.stopPropagation()
        }
  
        form.classList.add('was-validated')
      }, false)
    })
  })()

const jwtDecode = require('jwt-decode');
const select_user = $('#my-tests-user-select');
const orderList= $('#tests-tab-Content .card');
$(function () {
  const selectedMember = select_user.val();
  // //console.log(selectedMember)
  if (selectedMember != 0) { orderList.removeClass('active');}
  else{  orderList.addClass('active');}
    // EVENT HANDLER
    // On change family member
    select_user.on('change', (e) => {
        const selectedMemberId = $(e.currentTarget).val();
        // //console.log(selectedMemberId)
        if (selectedMemberId != 0) {
            orderList.removeClass('active');
            for (let i = 0; i < orderList.length; i++) {
                let currentOrderDetail = orderList.eq(i).attr('data-memberid');
                currentOrderDetail === selectedMemberId && orderList.eq(i).addClass('active');
            }
        } else {
            orderList.addClass('active');
        }

    })
});
